"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptDialog = void 0;
const react_1 = __importStar(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const dialog_1 = require("../../components/dialog/dialog");
exports.PromptDialog = react_1.forwardRef(function PromptDialog({ prompts, onConfirm, onCancel }, ref) {
    var _a;
    const prompt = (_a = prompts[0]) !== null && _a !== void 0 ? _a : { title: '', text: '' };
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: prompt.title, onConfirm: onConfirm, onCancel: onCancel }, () => react_1.default.createElement(Typography_1.default, null, prompt.text)));
});
//# sourceMappingURL=prompt-dialog.js.map